import { render } from "./GolfTabs.vue?vue&type=template&id=6a5303c3&scoped=true"
import script from "./GolfTabs.vue?vue&type=script&lang=js"
export * from "./GolfTabs.vue?vue&type=script&lang=js"

import "./GolfTabs.vue?vue&type=style&index=0&id=6a5303c3&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6a5303c3"]])

export default __exports__